import * as Scrivito from "scrivito";
import * as React from "react";

const HomepageComponent = ({ _page }) => {
  return <div>Welcome to the Homepage!</div>;
};

Scrivito.provideComponent("Homepage", HomepageComponent);
